import type { ComponentType } from "react";

type KpiIcon = ComponentType<{ size?: number; className?: string }>;

type KpiCardProps = {
  title: string;
  value: string;
  hint: string;
  Icon: KpiIcon;
  iconBgClass: string;
  iconColorClass?: string;
  hintClassName: string;
  titleClassName?: string;
  valueClassName?: string;
  className?: string;
};

export function KpiCard({
  title,
  value,
  hint,
  Icon,
  iconBgClass,
  iconColorClass = "",
  hintClassName,
  titleClassName = "text-sm font-medium text-slate-500",
  valueClassName = "mt-2 text-2xl font-semibold tabular-nums tracking-tight text-slate-900",
  className = "",
}: KpiCardProps) {
  return (
    <div
      className={`rounded-xl border border-slate-200 bg-white p-4 shadow-sm ${className}`.trim()}
    >
      <div className="flex items-start justify-between gap-2">
        <span className={titleClassName}>{title}</span>
        <span
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${iconBgClass}`}
        >
          <Icon className={`h-4 w-4 ${iconColorClass}`} aria-hidden />
        </span>
      </div>
      <p className={valueClassName}>{value}</p>
      <p className={hintClassName}>{hint}</p>
    </div>
  );
}
